import Taktivent from '../assets/images/taktivent.main.png';
import NomenVerb from '../assets/images/nomenverb.png';

export const projects = [
  {
    id: 'nomenverb',
    title: 'NomenVerbTrainer',
    image: NomenVerb,
    role: 'iOS Developer',
    techStack: ['Swift', 'SwiftUI', 'AVSpeechSynthesizer'],
    description:
      'A privacy-first iOS app for learning German vocabulary. 578 hand-curated cards across CEFR A2–C1 with five study modes (flashcards, typing, multiple choice, translation, mixed), daily streaks, Apple text-to-speech, and a bilingual UI (Japanese / English). All progress stored locally — no accounts, no analytics.',
    liveUrl: null, // TODO: App Store URL once published
    githubUrl: null, // TODO: GitHub URL if open source
    privacyPolicyUrl: '/privacy-policy.html',
    year: 2026,
  },
  {
    id: 'taktivent',
    title: 'Taktivent',
    image: Taktivent,
    role: 'Fullstack Developer',
    techStack: ['Ruby on Rails', 'React', 'WebSocket'],
    description:
      'Real-time feedback app for performers. A flyer page transforms into the live program when the event starts, then aggregates audience ratings and responses in real time.',
    liveUrl: 'https://taktivent.herokuapp.com/',
    githubUrl: 'https://github.com/Allllisha/taktivent',
    privacyPolicyUrl: null,
    year: 2022,
  },
];
